import { Injectable } from '@angular/core';
import { AlertController } from '@ionic/angular';

@Injectable()
export class AlertProvider {
  warningTitle: string = 'Προσοχή';
  errorTitle: string = 'Σφάλμα';
  successTitle: string = 'Επιτυχία';

  constructor(public alertCtrl: AlertController) {
    // console.log('Hello AlertProvider Provider');
  }
  //todo debrecate
  async showErrorMultiple(title, errors) {
    let errorInputs = [];
    let txt = '';
    if (!Array.isArray(errors)) {
      errors = [errors];
    }
    errors.forEach((error) => {
      // errorInputs.push({
      //   type: 'checkbox',
      //   label: error.Message,
      //   value: 'value1',
      //   checked: true
      // })
      txt += '--' + error.Message + '<br>';
    });

    const myAlert = await this.alertCtrl.create({
      header: title,
      message: txt,

      // subTitle: msg,
      buttons: [
        {
          text: 'Ok',
          handler: () => {
            //  return cb('cancel')
          },
        },
      ],
      // inputs: errorInputs
    });
    await myAlert.present();
  }

  async showRadio(title, inputs, cb) {
    inputs = inputs.map((inp, ind) => {
      return {
        name: 'radio' + ind,
        type: 'radio',
        label: inp.label,
        value: inp,
        checked: inp.checked,
      };
    });

    let myAlert = await this.alertCtrl.create({
      header: title,
      inputs: inputs,
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
        },
        {
          text: 'Ok',
          handler: (data) => {
            // console.log(data)
            return cb(data);
            // this.testRadioOpen = false;
            // this.testRadioResult = data;
          },
        },
      ],
    });

    await myAlert.present();
  }

  async showWarn(msg: string) {
    let alert = await this.alertCtrl.create({
      header: this.warningTitle,
      subHeader: msg,
      buttons: [
        {
          text: 'Ok',
          handler: () => {},
        },
      ],
    });
    await alert.present();
  }

  async showError(msg: string) {
    let alert = await this.alertCtrl.create({
      header: this.errorTitle,
      subHeader: msg,
      buttons: [
        {
          text: 'Ok',
          handler: () => {},
        },
      ],
    });
    await alert.present();
  }

  async showPermision(title, msg, permision, cb) {
    return new Promise(async (resolve, reject) => {
      let alert = await this.alertCtrl.create({
        header: title,
        message: msg,
        buttons: [
          {
            text: 'Επιστροφή',
            handler: () => {
              resolve(false);
              // return ('cancel')
            },
          },
          {
            text: permision,
            handler: () => {
              resolve(true);
            },
          },
        ],
      });
      await alert.present();
    });
  }

  async showSuccess(msg: string) {
    let alert = await this.alertCtrl.create({
      header: this.successTitle,
      subHeader: msg,
      buttons: [
        {
          text: 'Ok',
          handler: () => {
            // return 'ok'
          },
        },
      ],
    });
    await alert.present();
  }

  async showNeedAccept(msg: string, cb) {
    let alert = await this.alertCtrl.create({
      header: '',
      subHeader: msg,
      buttons: [
        {
          text: 'Αποδοχή',
          handler: () => {
            return cb('ok');
          },
        },
      ],
    });
    await alert.present();
  }

  async showEasySignInput(phone, cb) {
    const prompt = await this.alertCtrl.create({
      header: 'Στοιχεία Πελάτη',
      message: 'Συμπληρώστε τον αριθμό τηλεφώνου του πελάτη',
      inputs: [
        {
          name: 'phone',
          type: 'tel',
          placeholder: 'Aρ. Kινητού',
          value: phone,
        },
      ],
      buttons: [
        {
          text: 'Ακύρωση',
          handler: (data) => {
            return cb('cancel');
          },
        },
        {
          text: 'Αποστολή',
          handler: (data) => {
            return cb(data);
          },
        },
      ],
    });
    await prompt.present();
  }

  async showEmailInfo(cb) {
    const prompt = await this.alertCtrl.create({
      header: 'Στοιχεία Πελάτη',
      message: 'Συμπληρώστε τα στοιχεία',
      inputs: [
        {
          name: 'name',
          type: 'text',
          placeholder: 'Όνομα',
        },
        {
          name: 'email',
          type: 'email',
          placeholder: 'E-mail',
        },
      ],
      buttons: [
        {
          text: 'Ακύρωση',
          handler: (data) => {
            return cb('cancel');
          },
        },
        {
          text: 'Αποστολή',
          handler: (data) => {
            return cb(data);
          },
        },
      ],
    });
    await prompt.present();
  }

  async showInterest(cb) {
    const prompt = await this.alertCtrl.create({
      header: 'Στοιχεία Πελάτη',
      message: 'Παρακαλώ συμπληρώστε',
      inputs: [
        {
          name: 'name',
          type: 'text',
          placeholder: 'Όνομα',
        },
        {
          name: 'email',
          type: 'email',
          placeholder: 'E-mail',
        },
        {
          name: 'phone',
          type: 'tel',
          placeholder: 'Τηλέφωνο',
        },
      ],
      buttons: [
        {
          text: 'Ακύρωση',
          handler: (data) => {
            return cb('cancel');
          },
        },
        {
          text: 'Αποστολή',
          handler: (data) => {
            console.log('Saved clicked');
            return cb(data);
          },
        },
      ],
    });
    await prompt.present();
  }

  async paymentSelect(inputs, cb) {
    const prompt = await this.alertCtrl.create({
      header: 'Τρόπος Εξόφλησης',
      message: 'Παρακαλώ επιλέξτε τρόπο εξόφλησης',
      inputs: inputs,
      buttons: [
        {
          text: 'Ακύρωση',
          handler: (data) => {
            return cb();
          },
        },
        {
          text: 'Αποθήκευση',
          handler: (data) => {
            return cb(data);
          },
        },
      ],
    });
    await prompt.present();
  }

  async filterPrompt(inputs, cb) {
    const prompt = await this.alertCtrl.create({
      header: 'Ταξινόμηση',
      inputs: inputs,
      buttons: [
        {
          text: 'Ακύρωση',
          handler: (data) => {
            return cb('cancel');
          },
        },
        {
          text: 'Εφαρμογή',
          handler: (data) => {
            return cb(data);
          },
        },
      ],
    });
    await prompt.present();
  }

  async getRadio(header, subHeader, acceptTitle, rejectTitle, inputs) {
    let resolveFunction: (confirm: any) => void;
    const promise = new Promise<any>((resolve) => {
      resolveFunction = resolve;
    });

    const prompt = await this.alertCtrl.create({
      header: header,
      subHeader: subHeader,
      inputs: inputs,
      buttons: [
        {
          text: rejectTitle,
          role: 'cancel',
          handler: () => resolveFunction(false),
        },
        {
          text: acceptTitle,
          handler: (val) => resolveFunction(val),
        },
      ],
    });

    await prompt.present();
    return promise;
  }

  async getPermission(header, subHeader, acceptTitle, rejectTitle) {
    let resolveFunction: (confirm: boolean) => void;
    const promise = new Promise<boolean>((resolve) => {
      resolveFunction = resolve;
    });

    const prompt = await this.alertCtrl.create({
      header: header,
      subHeader: subHeader,
      mode: 'ios',
      buttons: [
        {
          text: rejectTitle,
          role: 'cancel',
          handler: () => resolveFunction(false),
        },
        {
          text: acceptTitle,
          handler: () => resolveFunction(true),
        },
      ],
    });

    await prompt.present();
    return promise;
  }

  //TODO debrecate
  async getMultiValue(header, subHeader, acceptTitle, rejectTitle, inputs) {
    let resolveFunction: (confirm: boolean) => void;
    const promise = new Promise<boolean>((resolve) => {
      resolveFunction = resolve;
    });

    const prompt = await this.alertCtrl.create({
      header: header,
      subHeader: subHeader,
      inputs: inputs,
      buttons: [
        {
          text: rejectTitle,
          role: 'cancel',
          handler: () => resolveFunction(false),
        },
        {
          text: acceptTitle,
          handler: () => resolveFunction(true),
        },
      ],
    });

    await prompt.present();
    return promise;
  }
}
